'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactScroll = require('react-scroll');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _EduCenterIndividual = require('./EduCenterIndividual.css');

var _EduCenterIndividual2 = _interopRequireDefault(_EduCenterIndividual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TooltipText = (_dec = (0, _reactCssModules2.default)(_EduCenterIndividual2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TooltipText, _Component);

  function TooltipText(props) {
    (0, _classCallCheck3.default)(this, TooltipText);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TooltipText.__proto__ || (0, _getPrototypeOf2.default)(TooltipText)).call(this, props));

    var tip = {
      'tickers': ['tickers', 'An abbreviation used to identify a publicly traded stock or mutual fund'],
      'target-date-fund': ['target date fund', 'Mutual funds that are selected based on the year the account holder plans to retire (the "target date")'],
      'default-option': ['default option', 'An investment option in which a mutual fund or funds are automatically selected for an employee if they are signed up for the plan but have not yet selected an option'],
      'mutual-funds': ['mutual funds', 'A type of investment that enables employees to invest in stocks, bonds, and other securities, usually grouped by investment objective'],
      'plan-administrator': ['plan administrator', 'The person responsible for managing a retirement plan including the plan’s investment options'],
      'fiduciary-duty': ['fiduciary duty', 'A legal and ethical duty to act solely in the interest of retirement plan participants']
    }[props.tipId || null];

    _this.state = {
      tip: tip
    };
    return _this;
  }

  (0, _createClass3.default)(TooltipText, [{
    key: 'render',
    value: function render() {
      var tip = this.state.tip;


      if (!tip) {
        return null;
      }

      var _tip = (0, _slicedToArray3.default)(tip, 2),
          tipName = _tip[0],
          tipText = _tip[1];

      //


      return _react2.default.createElement(
        'span',
        {
          styleName: 'tooltip-text',
          'data-multiline': true,
          'data-effect': 'solid',
          'data-tip': _format2.default.tooltipHtml(tipText),
          'data-html': true,
          'data-place': 'top',
          'data-for': 'tooltip-' + this.props.tipId
        },
        tipName
      );
    }
  }]);
  return TooltipText;
}(_react.Component), _class2.propTypes = {
  tipId: _react.PropTypes.string.isRequired
}, _temp)) || _class);
var EduCenter = (_dec2 = (0, _reactCssModules2.default)(_EduCenterIndividual2.default, { allowMultiple: true }), _dec2(_class3 = function (_Component2) {
  (0, _inherits3.default)(EduCenter, _Component2);

  function EduCenter(props) {
    (0, _classCallCheck3.default)(this, EduCenter);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (EduCenter.__proto__ || (0, _getPrototypeOf2.default)(EduCenter)).call(this, props));

    var emailTo = '';
    var emailSubject = 'Retirement plan sustainability';

    var planAdminEmailText = '\nDear Plan Administrator,\n\nI am an employee of [Company Name], and I participate in our company retirement plan. I am writing to ask about environmentally and socially sustainable investment options in the plan.\n\nI am concerned about the financial risks associated with investing my retirement savings in unsustainable industries. For example, laws curbing the use of fossil fuels are being put in place, energy efficiency measures are being implemented across nearly every sector of the economy, and renewable energy is driving down demand for fossil fuel-based energy. These changes pose substantial financial risk to fossil fuel companies. One example of this growing risk: over the past five years, the largest U.S coal companies have gone bankrupt, while other U.S. based coal firms have lost nearly 90% of their stock value.\n\nI believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find out what companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any fossil free, sustainable investment options? Is the default option of the retirement plan a sustainable investment?\n\nSustainable investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that \u201Cenvironmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment\u201D and can be used when making decisions related to fiduciary duty.\n\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\n\nBest,\n\n[Your Name]\n    ';

    var sustainabilityTeamEmailText = '\nDear Sustainability Team,\n\nI am an employee of [Company Name], and I participate in our company retirement plan. I am writing to ask about environmentally and socially sustainable investment options in the plan.\n\nI am concerned about the financial risks associated with investing my retirement savings in unsustainable industries. For example, laws curbing the use of fossil fuels are being put in place, energy efficiency measures are being implemented across nearly every sector of the economy, and renewable energy is driving down demand for fossil fuel-based energy. These changes pose substantial financial risk to fossil fuel companies. One example of this growing risk: over the past five years, the largest U.S coal companies have gone bankrupt, while other U.S. based coal firms have lost nearly 90% of their stock value.\n\nI believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find out what companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any fossil free, sustainable investment options? Is the default option of the retirement plan a sustainable investment?\n\nSustainable investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that \u201Cenvironmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment\u201D and can be used when making decisions related to fiduciary duty.\n\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\n\nBest,\n\n[Your Name]\n    ';

    var colleagueEmailText = '\nDear [colleague],\n\nI just found out my 401(k) investments are funding fossil fuels and companies that are burning down the Amazon rainforest.\n\nUnfortunately, the same may be true for you. You can learn more at this free tool with data on what\'s inside the mutual funds offered by 401(k) plans.\n\nhttps://investyourvalues.org/\n\nFor most companies, the default option is invested in fossil fuels, deforestation, arms manufacturers, and companies that score poorly on gender equality.\n\nI care about these issues and do not want my retirement savings to support companies that are destroying the environment and fueling social inequality.\n\nWe need to have more sustainable and climate-friendly investment options in our retirement plan, if we want to support an economy that is based on justice and sustainably through our retirement investments.\n\nThank you for taking the time to listen, and look forward to hearing from you soon.\n\nBest,\n\n[Your Name]\n    ';

    var planAdminEmailHref = 'mailto:' + emailTo + '?subject=' + encodeURIComponent(emailSubject) + '&body=' + encodeURIComponent(planAdminEmailText);

    var sustainabilityTeamEmailHref = 'mailto:' + emailTo + '?subject=' + encodeURIComponent(emailSubject) + '&body=' + encodeURIComponent(sustainabilityTeamEmailText);

    var colleagueEmailHref = 'mailto:' + emailTo + '?subject=' + encodeURIComponent(emailSubject) + '&body=' + encodeURIComponent(colleagueEmailText);

    _this2.state = {
      title: 'Five steps to a sustainable retirement plan',
      description: 'Resources for people to take action to make their employer-offered retirement plan more sustainable.',
      url: _config2.default.domain + _config2.default.routes.eduCenterIndividual,
      planAdminEmailHref: planAdminEmailHref,
      sustainabilityTeamEmailHref: sustainabilityTeamEmailHref,
      colleagueEmailHref: colleagueEmailHref
    };
    return _this2;
  }

  (0, _createClass3.default)(EduCenter, [{
    key: 'render',
    value: function render() {
      var finRisk1 = require('../../../static/images/fin-risk-oil-chart.jpg');
      var finRisk2 = require('../../../static/images/fin-risk-deforestation.jpg');
      var navIcons = {
        1: require('../../../static/images/action-center-employees/icon1.jpg'),
        2: require('../../../static/images/action-center-employees/icon2.jpg'),
        3: require('../../../static/images/action-center-employees/icon3.jpg'),
        4: require('../../../static/images/action-center-employees/icon4.jpg'),
        5: require('../../../static/images/action-center-employees/icon5.jpg')
      };

      var _state = this.state,
          planAdminEmailHref = _state.planAdminEmailHref,
          sustainabilityTeamEmailHref = _state.sustainabilityTeamEmailHref,
          colleagueEmailHref = _state.colleagueEmailHref;

      //

      return _react2.default.createElement(
        'div',
        { id: 'top' },
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _container2.default.helmet(this.state.title, this.state.description, this.state.url),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h1',
              { styleName: 'small-page-title' },
              this.state.title
            ),
            _react2.default.createElement(
              'section',
              null,
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Are your retirement savings funding the climate crisis? If you don\u2019t know, you\u2019re not alone. Over 100 million employees across the U.S. have over $10 trillion invested in retirement savings, but very few know which companies they are funding with their retirement dollars. Using this toolkit, you will learn how to lower your financial risks from unsustainable investments and maybe even help your co-workers do the same.'
                )
              )
            ),
            _react2.default.createElement(
              'nav',
              { styleName: 'icon-nav' },
              [[0, 'learn-about-the-financial-risks-of-unsustainable-investments', 'Learn about the financial risks of unsustainable investments'], [0, 'know-what-you-own', 'Know what you own'], [0, 'take-action', 'Take action'], [0, 'become-a-change-agent', 'Become a change agent'], [0, 'join-the-movement', 'Join the movement']].map(function (e, i) {
                return _react2.default.createElement(
                  'button',
                  {
                    key: e[1],
                    styleName: 'scroll-to-item'
                  },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      to: e[1],
                      spy: true,
                      smooth: true,
                      offset: 0,
                      duration: 500,
                      title: e[2]
                    },
                    _react2.default.createElement('img', {
                      src: navIcons[i + 1],
                      alt: e[2]
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'level-' + e[0] },
                      e[2]
                    )
                  )
                );
              })
            ),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'answer' },
              _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement('div', { styleName: 'anchor', id: 'learn-about-the-financial-risks-of-unsustainable-investments' }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'answer-subtitle-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-subtitle-bbl' },
                    '1'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'Learn about the financial risks of unsustainable investments'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer-info' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'text-img-cols' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'text-img-cols-text' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        'Unsustainable investments could put your 401(k) at risk'
                      ),
                      _react2.default.createElement(
                        'p',
                        null,
                        'There is a widespread myth that investing sustainably means sacrificing returns. But if anything, the evidence suggests the opposite is true. ',
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: _config2.default.routes.eduCenterFinRisks,
                            title: 'Financial risks of unsustainable investments',
                            xstrong: true
                          },
                          'Learn more',
                          _react2.default.createElement(_components.LinkIcon, null)
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'text-img-cols-img' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.eduCenterFinRisks,
                          title: 'Financial risks of unsustainable investments'
                        },
                        _react2.default.createElement('img', {
                          src: finRisk1,
                          alt: 'Financial risks of unsustainable investments'
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'text-img-cols' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'text-img-cols-text' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        'Your retirement plan is fueling the climate crisis and social inequality'
                      ),
                      _react2.default.createElement(
                        'p',
                        null,
                        'Companies hidden in your retirement plan may be fueling deforestation, the use of fossil fuels, and even contributing to societal challenges like gender inequality and mass incarceration. ',
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: _config2.default.routes.issues,
                            title: 'The issues',
                            xstrong: true
                          },
                          'Learn more',
                          _react2.default.createElement(_components.LinkIcon, null)
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'text-img-cols-img' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.issues,
                          title: 'The issue'
                        },
                        _react2.default.createElement('img', {
                          src: finRisk2,
                          alt: 'The issue'
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(_components.ScrollToTop, null),
                  _react2.default.createElement('hr', null)
                )
              ),
              _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement('div', { styleName: 'anchor', id: 'know-what-you-own' }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'answer-subtitle-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-subtitle-bbl' },
                    '2'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'Know what you own'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Now that you understand the risk associated with unsustainable retirement investments, it\u2019s time to find out if your investments are exposed to these risks.'
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'See if we\u2019ve scored your company'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'If you work at a big company, we might have already graded your retirement plan. To find out, visit our ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.plans,
                        title: 'The data: Retirement plans',
                        xstrong: true
                      },
                      'retirement plans page'
                    ),
                    '. If you don\u2019t see your company, don\u2019t fret: you can look up your funds by following the steps below.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.plans,
                        title: 'The data: Retirement plans',
                        transparentbutton: true
                      },
                      'Retirement plans',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Find your plan lineup'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'To start, log into your retirement portal to look up what funds are available to you, and write down the names or ',
                    _react2.default.createElement(TooltipText, { tipId: 'tickers' }),
                    '. More likely than not, your company has selected a ',
                    _react2.default.createElement(TooltipText, { tipId: 'target-date-fund' }),
                    ' as the ',
                    _react2.default.createElement(TooltipText, { tipId: 'default-option' }),
                    '. If you are not invested in a target date, then you are likely invested in ',
                    _react2.default.createElement(TooltipText, { tipId: 'mutual-funds' }),
                    '.'
                  ),
                  _react2.default.createElement(_reactTooltip2.default, { id: 'tooltip-tickers' }),
                  _react2.default.createElement(_reactTooltip2.default, { id: 'tooltip-target-date-fund' }),
                  _react2.default.createElement(_reactTooltip2.default, { id: 'tooltip-default-option' }),
                  _react2.default.createElement(_reactTooltip2.default, { id: 'tooltip-mutual-funds' }),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Find your fund grades'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Use our database to look up our environmental and social ratings for your funds.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'two-cols-row' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'two-cols-col' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.targetDateFunds,
                          title: 'Target date funds',
                          transparentbutton: true
                        },
                        'Target date funds',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'two-cols-col' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.fff + '/funds',
                          title: 'Mutual funds and ETFs',
                          transparentbutton: true
                        },
                        'Mutual funds and ETFs',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(_components.ScrollToTop, null),
                  _react2.default.createElement('hr', null)
                )
              ),
              _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement('div', { styleName: 'anchor', id: 'take-action' }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'answer-subtitle-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-subtitle-bbl' },
                    '3'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'Take action'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer-info' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Identify the best person to speak with'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Your ',
                    _react2.default.createElement(TooltipText, { tipId: 'plan-administrator' }),
                    ' is the person responsible for adding options to your retirement plan. You may already have sustainable options available, so you should contact your plan administrator to find out (you may have to email HR to help you find your plan administrator).'
                  ),
                  _react2.default.createElement(_reactTooltip2.default, { id: 'tooltip-plan-administrator' }),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Contact your plan administrator'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Once you have the name and email of your plan administrator, it is time to contact them. Here\u2019s an email we have written for you to get started.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: planAdminEmailHref,
                        title: 'Email your plan admin',
                        targetBlank: true
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'take-action-icons' },
                        _react2.default.createElement(
                          'p',
                          null,
                          'Email your plan admin'
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-envelope' })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Make a switch'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'If you find out you do have access to sustainable funds that meet your investment needs, then you can make a switch. If you don\u2019t have sustainable options available, and management is not willing to add new options, it\u2019s time to move on to the next step.'
                  ),
                  _react2.default.createElement(_components.ScrollToTop, null),
                  _react2.default.createElement('hr', null)
                )
              ),
              _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement('div', { styleName: 'anchor', id: 'become-a-change-agent' }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'answer-subtitle-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-subtitle-bbl' },
                    '4'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'Become a change agent'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'If management is not willing to add sustainable options to your retirement plan, it is time to take your financial future into your own hands.'
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Reach out to the sustainability team'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'If you company has a sustainability team or department it is usually a good sign that your company cares about these issues, and they should be able to advocate on your behalf. You can use the same sample letter from above to reach out this team and start the conversation.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: sustainabilityTeamEmailHref,
                        title: 'Email your company\'s sustainability team',
                        targetBlank: true
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'take-action-icons' },
                        _react2.default.createElement(
                          'p',
                          null,
                          'Email your company\'s sustainability team'
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-envelope' })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Email your co-workers and form a coalition'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'If you\u2019re writing to someone in power, advocating on behalf of 20 or even 10 people carries a lot more weight than just one. One way to spur interest would be to share the results from our tools with your fellow employees. All plan participants are offered the same basket of mutual funds as you are, so they are probably asking the same questions are you are right now.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: colleagueEmailHref,
                        title: 'Email your colleagues',
                        targetBlank: true
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'take-action-icons' },
                        _react2.default.createElement(
                          'p',
                          null,
                          'Email your colleagues'
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-envelope' })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Keep pushing'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Management may not be responsive the first time you ask about sustainable investments. Be persistent \u2013 continue giving updates to your colleagues that you\u2019ve organized, and keep raising the issue. The most important thing to highlight is that ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.eduCenterFinRisks,
                        title: 'Financial risks of unsustainable investments',
                        xstrong: true
                      },
                      'unsustainable investing carries real financial risks.'
                    ),
                    ' Without sustainable investment options, employees are forced to assume those financial risks, which may be a violation of your retirement plan administrator\u2019s ',
                    _react2.default.createElement(TooltipText, { tipId: 'fiduciary-duty' }),
                    '.'
                  ),
                  _react2.default.createElement(_reactTooltip2.default, { id: 'tooltip-fiduciary-duty' }),
                  _react2.default.createElement(_components.ScrollToTop, null),
                  _react2.default.createElement('hr', null)
                )
              ),
              _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement('div', { styleName: 'anchor', id: 'join-the-movement' }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'answer-subtitle-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-subtitle-bbl' },
                    '5'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'Join the movement'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Now it is time to join the movement by advocating your power to invest in an economy that is based on justice and sustainability.'
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Sign up for updates'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'We\'ll let you know when new companies are added to our database.'
                  ),
                  _react2.default.createElement(_components.SignupForm, null),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Support ',
                    _react2.default.createElement(
                      'i',
                      null,
                      'As You Sow'
                    )
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'i',
                      null,
                      'As You Sow'
                    ),
                    ', the nonprofit behind Invest Your Values, has leveraged the power of shareholders to change the world\u2019s biggest corporations for good since 1992. Every day, your gift helps tackle today\u2019s toughest issues, like climate change, racial justice, ocean plastics, toxins in the food system, egregious CEO pay, and slavery in corporate supply chains. Consider joining our family of donors.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.donate,
                        title: 'Donate to As You Sow',
                        transparentdonatebutton: true
                      },
                      'Donate to ',
                      _react2.default.createElement(
                        'i',
                        null,
                        'As You Sow'
                      ),
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(_components.ScrollToTop, null),
                  _react2.default.createElement('hr', null)
                )
              )
            )
          )
        ),
        _react2.default.createElement(_components.HomeEduCenter, null)
      );
    }
  }]);
  return EduCenter;
}(_react.Component)) || _class3);
exports.default = EduCenter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EduCenterIndividual/EduCenterIndividual.js
// module id = 1474
// module chunks = 0